// extracted by mini-css-extract-plugin
export default {"Body":"um3bw_pM"};